module.exports = __webpack_public_path__ + "static/media/InterdimensionalFightersSS.9d00dd99.png";